import PropTypes from 'prop-types';
import styled from 'styled-components';

const Paragraph = styled.p`
  line-height: 1.5em;
  font-size: var(--regular);
  letter-spacing: 0;
  font-weight: ${({ bold }) => (bold ? 'var(--semi-bold)' : 'var(--normal)')};
`;

Paragraph.propTypes = {
  bold: PropTypes.bool,
};

export default Paragraph;
